import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../../Contexts/AuthProvider';
import { havingPermission } from '../../../utils/PermissionMatching';
import { DownArrowIcon } from '../../../utils/SVGIcon';
import cn from '../../../utils/cn';
import { useMenus } from '../MenuProvider';
import { SubMenuItem } from './SubMenu';

// Control Hover effect icon for menu
function ImgHoverTag({ imgFill, imgLine }) {
    return (
        <span className="double-img-hover inline-block relative h-5.5 w-5.5">
            <img
                src={imgFill}
                alt=""
                className="absolute w-full top-0 left-0 opacity-0 group-hover/link:opacity-100"
            />
            <img
                src={imgLine}
                alt=""
                className="absolute w-full top-0 left-0 opacity-100 group-hover/link:opacity-0"
            />
        </span>
    );
}

function MainMenuItem({ item, handleShowMenu, itemId, permissionAll = [] }) {
    if (!havingPermission(item, permissionAll)) {
        return null;
    }

    return (
        <>
            <NavLink
                to={item.path}
                onClick={(e) => handleShowMenu(e, item)}
                className={cn(
                    `group/link w-full flex  justify-center items-center gap-2 py-[7px] px-2.5 bg-white hover:bg-secondary text-primary-700 hover:text-white-100 rounded-md transition relative z-20`,
                    {
                        active: item.path === window?.location?.pathname.split('/')[1]
                    }
                )}
            >
                <div className="flex flex-row items-center w-full gap-4">
                    <ImgHoverTag imgFill={item.iconWF} imgLine={item.iconWL} />
                    <span className="menu-title text-base font-normal capitalize">
                        {item.title}
                    </span>
                </div>

                {/* If there is a submenu then the icon will show  */}
                {item?.subMenu && (
                    <span
                        className={`submenu-downarrow inline-block w-4 h-4 ${
                            item?.id === itemId ||
                            item?.path === window?.location?.pathname.split('/')[1]
                                ? 'rotate-180'
                                : 'rotate-0'
                        }`}
                    >
                        <DownArrowIcon />
                    </span>
                )}
            </NavLink>

            {item?.subMenu && (
                <SubMenuItem
                    subMenu={item?.subMenu}
                    isActive={
                        item?.id === itemId ||
                        item.path === window?.location?.pathname.split('/')[1]
                    }
                    permissionAll={permissionAll}
                />
            )}
        </>
    );
}

// Use for main menu item
function SidebarMenuPage({ links = [] }) {
    const { permissionAll, rand } = useAuth();
    const { menuOpen } = useMenus();
    const [itemId, setItemId] = useState(0);

    const handleShowMenu = (e, item) => {
        // Prevent default if there is a submenu
        if (item?.subMenu) {
            e.preventDefault();
        }

        // If there is a submenu then the icon will show
        if (itemId === item?.id) {
            setItemId(0);
        } else {
            setItemId(item?.id);
        }
    };

    return (
        <ul
            className={cn(
                `submenu-level-1 border-r border-primary-100 h-[calc(100vh_-_70px)] overflow-hidden p-4 pl-2.5 overflow-y-auto menu-scrollbar`,
                {
                    active: !menuOpen
                }
            )}
        >
            {links?.map((item) => (
                <li key={item?.id}>
                    <MainMenuItem
                        key={rand}
                        item={item}
                        handleShowMenu={handleShowMenu}
                        itemId={itemId}
                        permissionAll={permissionAll}
                    />
                </li>
            ))}
        </ul>
    );
}

export default SidebarMenuPage;
